var progressBar = (function() {

    var $progressBarElement, $progressBarProgress;
    var data = {
      popover_label: "",
      force_pill_title_display: false,
      current_step: 1,
      step_count: 1,
      pills: [
        {
          "icon": "",
          "title": "...",
          "step": 1,
          "state": "pristine",
          "css_class": "",
        }
      ]
    };

    function init($progressBar) {
      if (typeof $progressBar === 'object') {
        $progressBarElement = $progressBar;

        if ($progressBarElement.length === 1) {
          $progressBarProgress = $('.progress-bar', $progressBarElement);
          setup();
          setActivePillLabelParent();
        }
      }
      else {
        console.log("ProgressBar initialization failed. You must specify an HTML element ID.");
      }
    }

    function setup() {
      // Set progress data from json.
      var jsonData = $progressBarElement.children('#oad-progress-bar-data').text();
      if (typeof jsonData == "string" && jsonData.trim().length > 0) {

        data = JSON.parse(jsonData);
      }

      // Set goal count if required
      if (data.popover_label !== "") {
        var $labelElement = $('<div class="current-step"></div>');
        $labelElement.text(data.popover_label);
        // If current substep is 1, add an xtra class.
        var stepsWithPills = data.pills.map(p => p.step);
        if (stepsWithPills.includes(data.current_step)) {
          $labelElement.addClass('d-md-none');
        }
        $progressBarProgress.append($labelElement);
      }

      // Setup the pills
      for (var i = 0; i < data.pills.length; i++) {
        var pillData = data.pills[i];
        createPill(pillData);
      }

      setProgress();
    }

    function createPill(pillData) {
      var $pill;

      // Assigning the right HTML element to the pill object depending if a URL is provided from the JSON.
      if (pillData.url && pillData.url !== "#") {
        $pill = $('<a href="' + pillData.url + '" class="oad-progress-bar-step"></a>');
      }
      else {
        $pill = $('<div class="oad-progress-bar-step"></div>');
      }

      var $pillIcon = $('<i></i>');
      var $pillTitle = $('<span class="step-label"></span>');

      // Pill Icon
      if (!isNaN(parseInt(pillData.icon, 10))) {
        $pillIcon.text(pillData.icon);
      }
      else {
        $pillIcon.addClass(pillData.icon);
      }
      if (pillData.css_class) {
        $pillIcon.addClass(pillData.css_class);
      }

      $pill.append($pillIcon);

      // Pill Title/Tooltip
      if (pillData.state === "active" || data.force_pill_title_display === true) {
        $pillTitle.text(pillData.title);
        $pill.append($pillTitle);
      }
      else {
        $pill.tooltip({ title: pillData.title, offset: '0, 7', placement: 'bottom', container: $progressBarElement, delay: 100 });
      }

      // Pill State
      $pill.addClass(pillData.state);

      // Pill Positioning
      $pill.css('left', ((pillData.step - 1) * 100 / (data.step_count - 1)) + '%');

      // Adding the pill to the DOM
      $progressBarElement.append($pill);
    }

    function setProgress() {
      var stepLength = 100 / (data.step_count - 1);
      $progressBarProgress.css('width', stepLength * (data.current_step - 1) + '%');
    }

    function setActivePillLabelParent() {
      var viewportWidth = window.innerWidth;
      var $activePill = $('.oad-progress-bar-step.active', $progressBarElement).first();

      if (viewportWidth < 769) {
        var activeLabel = $activePill.children('.step-label').first();
        if (activeLabel.length == 1) {
          activeLabel.appendTo( $progressBarElement );
        }
      }
      else {
        var activeLabel = $progressBarElement.children('.step-label').first();
        if (activeLabel.length == 1) {
          activeLabel.appendTo( $activePill );
        }
      }
    }
    $(window).on('resize', function() {
        setActivePillLabelParent();
    });

    return {
        init: init
    }
});
document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector('header');
    const currentStepIcon = document.querySelector(".current-step-icon .oad-progress-bar")
    // const httpAttribute = currentStepIcon.outerHTML
    const currentStepLabel = document.querySelector(".current-step-icon .step-label")
    if (!header) {
        console.error('Header not found');
    }
    if (!currentStepIcon) {
        console.error('currentStepIcon not found');
    } else {
        console.log('currentStepIcon found:', currentStepIcon);
    }
    if (!currentStepLabel) {
        console.error('currentStepLabel not found');
    } else {
        console.log('currentStepLabel found:', currentStepLabel);
    }

    if (header && currentStepIcon && currentStepLabel) {
        const httpAttribute = currentStepIcon.outerHTML;

        currentStepIcon.parentElement.addEventListener("click", function (e) {
            e.preventDefault();
            $("body, html").animate({
                scrollTop: 0
            });
        });

        $(window).on('scroll resize', () => {
            if (window.scrollY > 80) {
                header.classList.add('scrolled');
                const activeStep = document.querySelector(".oad-progress-bar-step.active");
                const stepLabel = document.querySelector('.step-label');

                if (activeStep && stepLabel) {
                    currentStepIcon.innerHTML = activeStep.outerHTML;
                    currentStepLabel.textContent = stepLabel.textContent;
                    const stepLabelInIcon = currentStepIcon.querySelector('.step-label');
                    if (stepLabelInIcon) {
                        stepLabelInIcon.remove();
                    }
                } else {
                    if (!activeStep) {
                        console.error('Active step not found');
                    }
                    if (!stepLabel) {
                        console.error('Step label not found');
                    }
                }
            } else {
                if (header.classList.contains("scrolled")) {
                    header.classList.remove('scrolled');
                    $(window).trigger("resize")
                }
            }
        });
    }
});

